import {useRef} from "react";
import Moment from "react-moment";
import {useAuth} from "../../../contexts/UserContext";
import {comum} from "../../../styles/Themes/light";
import {IconAccept, IconAttachment, IconInProgress, IconInstruction} from "../../icons";
import {Pendency} from "../BlocoPendencias/styles";

export default function CardListaPendenciaComum({
    pendencia,
    resolvePendencia
}: {
    pendencia: any;
    resolvePendencia: () => void;
}) {

    const { user } = useAuth();

    const aboutSection = useRef<any>(null);
    const scrollDown = () => aboutSection.current.scrollIntoView();

    const defPendencias: any = {
        documentacao: 'Documentação',
        informacao: 'Instrução',
        orientacao: 'Orientação',
        correcao: 'Correção',
        s_informacao: 'Solicitação ' + (user.profile !== 'Solicitante' ? 'do Escritório' : '')
    }
    return (
        <Pendency>
            <div className="header">
                <div className="icon-title">
                    <IconInstruction color={comum.colors.primaryRed400}/>
                    {defPendencias[pendencia.tipo]}
                </div>
            {
            pendencia.resolvida !== 'sim'
                ? user.profile !== 'Solicitante' && pendencia.destino === 'usuario' && user.profile === 'comum'
                    ?   <div className="date-status">
                            <div className="date">
                                <Moment locale='pt-br'fromNow>{pendencia.criado}</Moment>
                            </div>
                            <div
                                className="status resolve"
                                onClick={resolvePendencia}
                            >
                                Responder
                            </div>
                        </div>
                    :   user.profile !== 'Solicitante' && pendencia.destino !== 'usuario' && user.profile !== 'comum'
                        ?   <div className="date-status">
                                <div className="date">
                                    <Moment locale='pt-br' fromNow>{pendencia.criado}</Moment>
                                </div>
                                <div
                                    className="status resolve"
                                    onClick={resolvePendencia}
                                >
                                    Responder
                                </div>
                            </div>
                        :   <div className="date-status"> 
                                <div className="date">
                                    <Moment locale='pt-br' fromNow>{pendencia.criado}</Moment>
                                </div>
                                <div className="status waiting">
                                    <IconInProgress />
                                    Aguardando
                                </div>
                            </div>
                :   
                    <div className="status-link">
                        <div className="status success">
                            <IconAccept />
                            Resolvida
                        </div>
                        <div 
                            className="button"
                            onClick={scrollDown}
                        >
                            <IconAttachment color="#000000" />                                                                             
                        </div>
                    </div>
            }
            </div>
            <div className="list">
                <p>{pendencia.descricao}</p>
                {
                    pendencia.resposta !== null
                    ?
                    <div className="answer">
                        <div className="title">Resposta:</div>
                        <div className="info">{pendencia.resposta}</div>
                    </div>
                    : ''
                }
            </div>
        </Pendency>
    )
}
